import { render } from "./ExportButton.vue?vue&type=template&id=3fa76790"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"
script.render = render

export default script